<template>
    <div v-if="loading" :class="`main-loader ${innerLoading ? 'inner-loader' : ''}`"><img :src="dynamicAsset" alt="Loading" /></div>
</template>

<script>
import { computed } from 'vue';

const svgLoaders = require.context('@/assets/media', true, /^\.\/[^/]+\/[^/]+_loader\.svg$/);
const pngLoaders = require.context('@/assets/media', true, /^\.\/[^/]+\/[^/]+_loader\.png$/);

function resolveLoaderAsset(clientName) {
    const svgKey = `./${clientName}/${clientName}_loader.svg`;
    const pngKey = `./${clientName}/${clientName}_loader.png`;
    if (svgLoaders.keys().includes(svgKey)) {
        return svgLoaders(svgKey);
    }
    if (pngLoaders.keys().includes(pngKey)) {
        return pngLoaders(pngKey);
    }
    throw new Error(`No loader image for "${clientName}" (_loader.svg or _loader.png)`);
}

export default {
    name: 'InnerLoader',
    props: {
        loading: {
            type: Boolean,
            default: false
        },
        innerLoading: {
            type: Boolean,
            default: false
        }
    },
    setup() {
        const ASSETS_CLIENT_NAME = process.env.VUE_APP_ASSETS_CLIENT_NAME;

        const dynamicAsset = computed(() => {
            return resolveLoaderAsset(ASSETS_CLIENT_NAME);
        });

        return {
            ASSETS_CLIENT_NAME,
            dynamicAsset
        };
    }
};
</script>

<style scoped lang="scss">
.main-loader {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 9999;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;

    img {
        display: block;
        max-width: 8rem;
        margin: 0 auto;
        height: auto;
        animation-name: loadingAnimation;
        animation-duration: 1.5s;
        animation-fill-mode: both;
        animation-iteration-count: infinite;
    }

    &.inner-loader {
        position: absolute;

        img {
            max-width: 6rem;
        }
    }
}

@keyframes loadingAnimation {
    0% {
        transform: scale(0.3) rotate(720deg);
        opacity: 0;
    }

    50% {
        transform: scale(1) rotate(0);
        opacity: 1;
    }

    100% {
        transform: scale(0.3) rotate(0);
        opacity: 0;
    }
}
</style>
